import { DEFAULT_TIME_ZONE, resolveTimeZone } from '@mervonn/shared-types';
import { useSession } from '../features/auth/useAuth';

/**
 * The IANA zone to show times in: the named branch's zone, else the tenant default. It comes from
 * the signed-in session, so every role has it (`GET /tenant` is admin-only). A branch-scoped user's
 * session lists only their own branches; anything unknown falls back to the tenant default, then
 * the platform default.
 */
export function useDisplayZone(branchId?: string | null): string {
  const session = useSession();
  const branchZone = branchId ? session.branch_time_zones?.[branchId] : undefined;
  return resolveTimeZone(branchZone ?? session.time_zone ?? DEFAULT_TIME_ZONE);
}
